import { useDashboardFeatureFlags } from '../../../../../../../../components/utils/DashboardFeatureFlags'
import { LINK_TO_HOMEPAGE_STEP_TYPE, PERKS_STEP_TYPE, POST_STEP_TYPE } from '../consts'
import { useMembershipsOnboardingQuery } from './useMembershipsOnboardingQuery'

export const useMembershipsOnboardingData = () => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const { membershipsOnboardingQuery } = useMembershipsOnboardingQuery(undefined, {
    enabled: dashboardFeatureFlags.memberships.enabled,
  })

  return {
    membershipsOnboardingQuery,
    onboardingSteps: membershipsOnboardingQuery.data?.steps,
    perksStep: membershipsOnboardingQuery.data?.steps.find((step) => step.type === PERKS_STEP_TYPE),
    postStep: membershipsOnboardingQuery.data?.steps.find((step) => step.type === POST_STEP_TYPE),
    linkToHomepageStep: membershipsOnboardingQuery.data?.steps.find(
      (step) => step.type === LINK_TO_HOMEPAGE_STEP_TYPE,
    ),
    isOnboardingCompleted: membershipsOnboardingQuery.data?.completed,
    isOnboardingHidden: membershipsOnboardingQuery.data?.hidden,
  }
}
